export const TICKET_LIMIT_PER_REQUEST = 2500
export const NUM_ROUNDS_TO_CHECK_FOR_REWARDS = 3
export const NUM_ROUNDS_TO_FETCH_FROM_NODES = 3